import {RootDynamicComponentHelper} from '@shared/helpers/root-dynamic-component-helper';
import {EmailBlastRecipientDialogDefEditorComponent} from '@features/admin-panel/components/dialog-definition-editors/email-blast-recipient-dialog-def-editor/email-blast-recipient-dialog-def-editor.component';
import {EmailBlastDetailDialogDefEditorComponent} from '@features/admin-panel/components/dialog-definition-editors/email-blast-detail-dialog-def-editor/email-blast-detail-dialog-def-editor.component';
import {DialogDefinitionDynamicHtmlEditorComponent} from '@features/admin-panel/components/dialog-definition-dynamic-html-editor/dialog-definition-dynamic-html-editor.component';
import {MapCompanyComponent} from '@features/admin-panel/components/map-company/map-company.component';
import {MapCompanyCellViewerComponent} from '@features/admin-panel/components/map-company-cell-viewer/map-company-cell-viewer.component';
import {UserListRolesCellViewerComponent} from '@features/admin-panel/components/user-company-roles-cell-viewer/user-list-roles-cell-viewer.component';
import {AdminPanelCompanyDetailFormComponent} from '@features/admin-panel/components/admin-panel-company-detail-form/admin-panel-company-detail-form.component';
import {AdminPanelCompanyUserListComponent} from '@features/admin-panel/components/admin-panel-company-user-list/admin-panel-company-user-list.component';
import {AdminPanelUserDetailFormComponent} from '@features/admin-panel/components/admin-panel-user-detail-form/admin-panel-user-detail-form.component';
import {AdminPanelUserPackageListComponent} from '@features/admin-panel/components/admin-panel-user-package-list/admin-panel-user-package-list.component';
import {AdminDashboardComponent} from '@features/admin-panel/components/admin-dashboard/admin-dashboard.component';
import {AdminDashboardCompany360Component} from '@features/admin-panel/components/admin-dashboard/company-360/admin-dashboard-company-360.component';
import {AdminDashboardSettingsComponent} from '@features/admin-panel/components/admin-dashboard/settings/admin-dashboard-settings.component';
import {AdminDashboardCompaniesComponent} from '@features/admin-panel/components/admin-dashboard/companies/admin-dashboard-companies.component';

// @dynamic
export class AdminPanelDynamicComponentHelper{
  public static components: any;
  public static init() {
    if (AdminPanelDynamicComponentHelper.components) {
      return;
    }
    const components = {};
    // components['AzureDataFactoryComponent'] = AzureDataFactoryComponent;
    components['EmailBlastRecipientDialogDefEditor'] = EmailBlastRecipientDialogDefEditorComponent;
    components['EmailBlastDetailDialogDefEditor'] = EmailBlastDetailDialogDefEditorComponent;
    components['DialogDefinitionDynamicHtmlEditor'] = DialogDefinitionDynamicHtmlEditorComponent;
    components['MapCompanyCellViewerComponent'] = MapCompanyCellViewerComponent;
    components['UserListRolesCellViewerComponent'] = UserListRolesCellViewerComponent;
    components['MapCompanyComponent'] = MapCompanyComponent;
    components['AdminPanelCompanyDetailFormComponent'] = AdminPanelCompanyDetailFormComponent;
    components['AdminPanelCompanyUserListComponent'] = AdminPanelCompanyUserListComponent;
    components['AdminPanelUserDetailFormComponent'] = AdminPanelUserDetailFormComponent;
    components['AdminPanelUserPackageListComponent'] = AdminPanelUserPackageListComponent;
    components['AdminDashboardComponent'] = AdminDashboardComponent;
    components['AdminDashboardCompany360Component'] = AdminDashboardCompany360Component;
    components['AdminDashboardSettingsComponent'] = AdminDashboardSettingsComponent;
    components['AdminDashboardCompaniesComponent'] = AdminDashboardCompaniesComponent;
    AdminPanelDynamicComponentHelper.components = components;
    RootDynamicComponentHelper.merge(components);
  }
  public static getComponentArray(): any[] {
    AdminPanelDynamicComponentHelper.init();
    const componentArray = [];
    Object.keys(AdminPanelDynamicComponentHelper.components).forEach(key => {
      componentArray.push(AdminPanelDynamicComponentHelper.components[key]);
    });
    return componentArray;
  }
  public static register(key: string, component: any) {
    AdminPanelDynamicComponentHelper.components[key] = component;
    RootDynamicComponentHelper.register(key, component);
  }
}
